import { formatChatMessage } from '../../utils/chatbot/messageFormatter';
import { Message } from '../../types/chat';
import { generateResponse } from '../openai/chatService';
import { isOpenAIAvailable } from '../../config/openai';

export const createUserMessage = (text: string): Message => ({
  id: Date.now().toString(),
  text: formatChatMessage(text),
  sender: 'user',
  timestamp: new Date()
});

export const createBotMessage = (text: string): Message => ({
  id: (Date.now() + 1).toString(),
  text: formatChatMessage(text),
  sender: 'bot',
  timestamp: new Date()
});

export const processMessage = async (
  message: string,
  conversationHistory: any[]
): Promise<string> => {
  try {
    if (!isOpenAIAvailable()) {
      return "Je suis désolé, le service de chat n'est pas disponible pour le moment. Veuillez contacter le support directement.";
    }

    const response = await generateResponse(message, conversationHistory);
    return formatChatMessage(response);
  } catch (error) {
    console.error('Error processing message:', error);
    return 'Je suis désolé, je rencontre des difficultés techniques. Veuillez réessayer.';
  }
};